import './square-modal.scss';

import PubSub from 'pubsub-js';
import { PageEvents } from './page';

const COMPONENT_NAME = 'square-modal';
const BEM = {
  BLOCK: COMPONENT_NAME,
  SQUARE_BOX: 'square-modal__square',
  SQUARE_BASE: 'square-modal__base',
  SQUARE_OPEN: 'square-modal__open',
  SQUARE_BACKDROP: 'square-modal__backdrop',
};

/**
 * version    1.0
 * class      <type> (SquareModal)
 * classdesc   SquareModal
 */
export class SquareModal {
  constructor($container = $('body')) {
    const self = this;

    this._els = {};
    this._els.container = $container;
    this._els.squareModalSection = this._els.container.find(`.${BEM.BLOCK}`);

    PubSub.subscribe(PageEvents.PAGE_READY, () => {
      this._els.squareModalSection.each(function () {
        self._initSingleInstance($(this));
      });
    });
  }

  // private methods
  _initSingleInstance($instanceEl) {
    const self = this;
    self._openSquareModal($instanceEl);
  }

  _openSquareModal($instanceEl) {
    const boxModal = $instanceEl.find(`.${BEM.SQUARE_BOX}`);
    const backdropBoxModal = $instanceEl.find(`.${BEM.SQUARE_BACKDROP}`);

    boxModal.on('click', function () {
      if ($(this).hasClass('square-modal__square--open')) {
        $(this).toggleClass('square-modal__square--open');
      } else {
        $(this).closest('.square-modal').find('.square-modal__square--open').removeClass('square-modal__square--open');
        $(this).toggleClass('square-modal__square--open');
      }

      if ($('.square-modal__square--open') && $('.square-modal__square--open').length > 0) {
        $('.square-modal__backdrop').addClass('square-modal__backdrop--open');
        $('body').addClass('modal-open');
      } else {
        $('.square-modal__backdrop').removeClass('square-modal__backdrop--open');
        $('body').removeClass('modal-open');
      }
    });

    backdropBoxModal.on('click', function () {
      $(this).closest('.square-modal').find('.square-modal__square--open').removeClass('square-modal__square--open');

      if ($('.square-modal__square--open') && $('.square-modal__square--open').length > 0) {
        $('.square-modal__backdrop').addClass('square-modal__backdrop--open');
        $('body').addClass('modal-open');
      } else {
        $('.square-modal__backdrop').removeClass('square-modal__backdrop--open');
        $('body').removeClass('modal-open');
      }
    });
  }
}
